import { FetchState } from "@/shared/types";
import { EmployerInterestRateState } from "@/admin/types";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";
import { getEmployerInterestRates } from "@/shared/api/userService";

export const initialState: EmployerInterestRateState = {
  fetchState: FetchState.Uninitialized,
  employerId: 0,
  interestRates: []
};

export const useEmployerInterestRateStore = defineStore("employerInterestRate", {
  state: (): EmployerInterestRateState => (_.cloneDeep(initialState)),
  actions: {
    loadInterestRates (employerId: number) {
      if (this.employerId === employerId) {
        return;
      }

      this.interestRates = [];

      if (employerId <= 0) {
          this.employerId = 0;
          return;
      }

      this.fetchState = FetchState.Loading;

      getEmployerInterestRates(employerId)
        .then(response => {
          this.employerId = employerId;
          this.fetchState = FetchState.Loaded;
          this.interestRates = response.data.interestRates;
        })
        .catch(error => {
          this.interestRates = [];
          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
